import Home from './routes/Home.svelte';
import Error401 from './routes/Error401.svelte'
import NoDashboard from './routes/NoDashboard.svelte';
import Settings from './lib/Settings.svelte';


export default {
    '/home': Home
};



